//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "my-account-menu",
  data(){
    return{
      menuItems: [
        {
          label: "My orders",
          url: "/my-account"
        },
        {
          label: "Logout",
          url: "/logout"
        }
      ]
    }
  }
}
